import { Button } from '@mui/material'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next';
import UndoIcon from '@mui/icons-material/Undo';

type Props = {
    onUndo: () => void;
    disabled: boolean;
}

const UndoButton = ({onUndo, disabled} : Props) => {
  const { t } = useTranslation();

  return (
    <Button variant={'contained'} color={'warning'} onClick={onUndo} disabled={disabled} startIcon={<UndoIcon/>}>
        <Trans>Undo</Trans>
    </Button>
  )
}

export default UndoButton;